import gql from 'graphql-tag';

export default gql `
query getUser($id: ID!){
    getUser(id: $id) {
            		id
					username
					email
					name
					goals
					voicePursuit
					gender
					Age
					voiceType
					voiceDescriptives
        	
    }
}`;


// WEBPACK FOOTER //
// ./src/components/queries/GetUserQuery.js